import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { SimpleModalComponent } from './simple.component';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        SvgIconModule,
    ],
    exports: [ SimpleModalComponent ],
    declarations: [ SimpleModalComponent ],
    entryComponents: [ SimpleModalComponent ],
})
export class SimpleModalModule {}
